<!-- 由 suu 创建于 2021-02-23 星期二 -->
<template>
  <div class="training-pro-top" v-if="info">
    <div class="tt-top">
      <div class="top-left">
        <img
          class="l-img"
          v-if="info.image && showImg"
          @error="handelImgError"
          :src="info.image"
          alt
        />
        <div class="left-info">
          <div class="i-name">
            {{ info.truename }}
            <div class="name-text">
              总上课
              <span>{{ info.train_num }}</span
              >节
            </div>
          </div>
          <div class="i-shop">{{ info.shopname }}</div>
        </div>
      </div>
      <div class="top-right">
        <div class="r-courses">
          上次评估
          <span>{{ Math.abs(info.diff_days) }}</span
          >天前
        </div>
        <div class="r-coach">主教练：{{ info.coachname }}</div>
      </div>
    </div>
    <div class="tt-body">
      <!-- 着重数据 -->
      <div class="body-top">
        <div class="top-item" @click="goTrend(0)">
          <i class="iconfont icon-tizhong3"></i>
          <div class="item-title">体重</div>
          <div class="item-nums">
            {{ info.weight_last }}{{ info.weight_unit }}
          </div>
          <div
            class="item-change"
            v-if="info.weight_contrast"
            :class="{ 'change-negative': negative(info.weight_contrast) }"
          >
            {{
              info.weight_contrast > 0
                ? '+' + info.weight_contrast
                : info.weight_contrast
            }}{{ info.weight_unit }}
          </div>
        </div>
        <div class="top-item" @click="goTrend(1)">
          <i class="iconfont icon-shuidi-6"></i>
          <div class="item-title">腰围</div>
          <div class="item-nums">
            {{ info.waist_last }}{{ info.waist_unit }}
          </div>
          <div
            class="item-change"
            v-if="info.waist_contrast"
            :class="{ 'change-negative': negative(info.waist_contrast) }"
          >
            {{
              info.waist_contrast > 0
                ? '+' + info.waist_contrast
                : info.waist_contrast
            }}{{ info.waist_unit }}
          </div>
        </div>
        <div class="top-item" @click="goTrend(2)">
          <i class="iconfont icon-zhongyaowei"></i>
          <div class="item-title">体脂率</div>
          <div class="item-nums">{{ info.bfr_last }}{{ info.bfr_unit }}</div>
          <div
            class="item-change"
            v-if="info.bfr_contrast"
            :class="{ 'change-negative': negative(info.bfr_contrast) }"
          >
            {{
              info.bfr_contrast > 0
                ? '+' + info.bfr_contrast
                : info.bfr_contrast
            }}{{ info.bfr_unit }}
          </div>
        </div>
      </div>
      <!-- 身体数据 -->
      <div class="body-list" v-if="showMore">
        <div class="list-title">
          <div class="title-item">{{ cntrastText }}</div>
          <div class="title-item">当前值</div>
        </div>
        <div
          class="list-item"
          @click="goTrend(item.trendId)"
          v-for="(item, index) in bodyList"
          :key="index"
        >
          <i
            class="iconfont"
            :class="[item.icon ? item.icon : '', item.flip ? 'icon-flip' : '']"
          ></i>
          <div class="item-title">{{ item.title }}</div>
          <!-- 变化 -->
          <div
            class="item-change"
            :class="{
              'change-negative': negative(info[item.val + '_contrast'])
            }"
          >
            <span v-if="info[item.val + '_contrast']"
              >{{
                info[item.val + '_contrast'] > 0
                  ? '+' + info[item.val + '_contrast']
                  : info[item.val + '_contrast']
              }}{{
                Number(info[item.val + '_contrast'])
                  ? info[item.val + '_unit']
                  : ''
              }}</span
            >
          </div>
          <div class="item-value">
            {{ info[item.val + '_last'] }}{{ info[item.val + '_unit'] }}
          </div>
        </div>
      </div>
      <div class="body-btn user-btn" @click="showMore = !showMore">
        <van-icon name="arrow-down" v-if="!showMore" />
        <van-icon name="arrow-up" v-else />
        {{ showMore ? '收起' : '展开' }}
      </div>
    </div>
    <!-- 蛛网图 -->
    <AbilityRadar
      class="ability-region"
      :info="radarInfo.data_map"
      v-if="radarInfo.data_map"
    ></AbilityRadar>
    <!-- 对比图 -->
    <!-- <div
      class="compare_wrap"
      @click="$router.push('body-file/compare-data?userid=' + uid)"
    >
      <div class="compare_notice">
        <span style="color:#333;">对比图</span>
      </div>
      <div class="compare_icon">
        <span class="notice_info">{{
          info.contrast_imgage === '0'
            ? '*您还没有对比图，需要上传对比图哦'
            : '您已经有对比图了，快去看看吧'
        }}</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div> -->
  </div>
</template>

<script>
import AbilityRadar from './ability-radar.vue'

export default {
  name: 'training-pro-top',

  components: { AbilityRadar },

  props: {},

  data() {
    return {
      uid: this.$route.query.uid,
      showImg: true,
      bodyList: [
        {
          title: '臀围',
          icon: 'icontunwei1',
          flip: false,
          trendId: 4,
          val: 'hip'
        },
        {
          title: '胸围',
          icon: 'iconwode-jiankangshujuxiongwei',
          flip: false,
          trendId: 3,
          val: 'bust'
        },
        {
          title: '基础代谢',
          icon: 'iconicon-huoyan',
          flip: false,
          trendId: 7,
          val: 'bm'
        },
        {
          title: 'BMI',
          icon: 'iconbianzu42',
          flip: false,
          trendId: 8,
          val: 'bmi'
        },
        {
          title: '骨骼肌',
          icon: 'iconbianzu42',
          flip: false,
          // trendId: 9,
          val: 'sm'
        },
        {
          title: '右臂围',
          icon: 'iconjianshen-3',
          flip: false,
          val: 'arm_r'
        },
        {
          title: '左臂围',
          icon: 'iconjianshen-3',
          flip: true,
          val: 'arm_l'
        },
        {
          title: '右大腿围',
          icon: 'icontuibu',
          flip: true,
          val: 'thigh_r'
        },
        {
          title: '左大腿围',
          icon: 'icontuibu',
          flip: false,
          val: 'thigh_l'
        },
        {
          title: '右小腿围',
          icon: 'icontuibushengjiang',
          flip: false,
          val: 'calf_r'
        },
        {
          title: '左小腿围',
          icon: 'icontuibushengjiang',
          flip: true,
          val: 'calf_l'
        }
      ],
      radarInfo: {},
      showMore: false,
      info: null,
      cntrastText: '与最高值对比',
      ufrom: this.$route.query.ufrom || '' // 当前用户来源 身份 vip 为会员用户
    }
  },

  filters: {
    formatUnit: (value) => {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  computed: {},

  watch: {},

  activated() {
    // console.log('====================================');
    // console.log('1122试试');
    // console.log('====================================');
  },

  created() {
    this.uid =
      this.$route.query.uid ||
      this.$route.query.userid ||
      this.$store.state.user.user.uid ||
      ''
    this.getInfo()
    this.getDataMapLatest()
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 头像加载出错
    handelImgError() {
      this.showImg = false
    },
    // 跳转趋势页面
    goTrend(i) {
      if (i || i === 0) {
        this.$router.push(`training-trend?new=1&type=${i}&uid=${this.uid}`)
      }
    },
    // 判断正负数
    negative(val) {
      return String(val).slice(0, 1) === '-'
    },
    /**
     * 获取用户身体数据
     */
    getInfo() {
      this.$http
        .get(
          'member/Test?a=bodyDataContrast',
          {
            uid: this.uid
          },
          true
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.info = res.data.data
            this.uid = this.info.uid
            this.cntrastText = this.info.contrast_column
            this.$emit('getUid', { uid: this.uid })
          } else {
            this.$dialog.alert({ message: res.data.msg })
          }
        })
        .catch((err) => {
          this.$dialog.alert({ message: '网络错误' })
          // this.$Indicator.close()
        })
    },
    // 获取蛛网图信息
    getDataMapLatest() {
      this.$http
        .get(
          'coach/TrainReport?a=dataMapLatest',
          {
            uid: this.uid
          },
          true
        )
        .then((res) => {
          // this.$Indicator.close()
          if (res.data.code === 200) {
            this.radarInfo = res.data.data
          } else {
            // this.$MessageBox.alert(res.data.msg)
          }
        })
        .catch((err) => {
          // this.$MessageBox.alert('网络错误')
          // this.$Indicator.close()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.training-pro-top {
  width: 100%;
  box-sizing: border-box;
  padding: 4.3vw;
  background-color: #fff;
  color: #000;
  .tt-top {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .top-left {
      display: flex;
      align-items: center;
      .l-img {
        width: 12.8vw;
        height: 12.8vw;
        border-radius: 50%;
        margin-right: 3.7vw;
      }
      .left-info {
        .i-name {
          font-size: 4.3vw;
          font-weight: 600;
          display: flex;
          align-items: baseline;
          .name-text {
            font-size: 3.2vw;
            color: rgba(0, 0, 0, 0.7);
            margin-left: 4.3vw;
            span {
              color: #dc0050;
            }
          }
        }
        .i-shop {
          font-size: 3.2vw;
          color: rgba(0, 0, 0, 0.5);
          margin-top: 1.1vw;
        }
      }
    }
    .top-right {
      text-align: right;
      .r-courses {
        font-size: 3.2vw;
        span {
          color: #dc0050;
        }
      }
      .r-coach {
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.5);
        margin-top: 1.1vw;
      }
    }
  }
  .tt-body {
    width: 100%;
    box-sizing: border-box;
    border-radius: 1.6vw;
    border: solid 0.3vw #f1f1f1;
    margin-top: 5.3vw;
    position: relative;
    transition: all 1s;
    padding-bottom: 7.2vw;
    margin-bottom: 4.5vw;
    .body-btn {
      padding: 1vw 5.3vw;
      background-color: #ffffff;
      border-radius: 3.5vw;
      border: solid 0.3vw #e7e7e7;
      display: flex;
      align-items: center;
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.5);
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 50%);
      i {
        font-size: 2.7vw;
        margin-right: 2.1vw;
      }
    }
    .body-top {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      // align-items: center;
      justify-content: space-around;
      padding: 4.8vw 0;
      .top-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        i.iconfont {
          font-size: 6.9vw;
          color: rgba($color: #000000, $alpha: 0.5);
        }
        .item-title {
          font-size: 3.5vw;
          margin-top: 2.4vw;
        }
        .item-nums {
          font-size: 5.3vw;
          font-weight: 600;
          margin-top: 1.3vw;
        }
        .item-change {
          padding: 0.8vw 2.1vw;
          background-color: #dc0050;
          border-radius: 1.1vw;
          font-size: 2.7vw;
          font-weight: 600;
          color: #fff;
          margin-top: 2.7vw;
        }
        .change-negative {
          background-color: #2882e9;
        }
      }
    }
    .body-list {
      width: 100%;
      box-sizing: border-box;
      padding: 0 4.3vw;
      .list-title {
        width: 100%;
        padding: 0 3.2vw;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        .title-item {
          min-width: 20vw;
          text-align: right;
        }
      }
      .list-item {
        width: 100%;
        height: 10.7vw;
        padding: 0 3.2vw;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 0.5vw;
        i.iconfont {
          font-size: 4.3vw;
          color: rgba($color: #000000, $alpha: 0.5);
        }
        i.icon-flip {
          transform: rotateY(180deg);
        }
        .item-title {
          font-size: 3.5vw;
          margin-left: 4.8vw;
        }
        .item-change {
          flex: 1;
          font-size: 2.7vw;
          color: #dc0050;
          text-align: right;
        }
        .change-negative {
          color: #2882e9;
        }
        .item-value {
          min-width: 20vw;
          text-align: right;
        }
      }
      .list-item:nth-child(odd) {
        background-color: #f7f7f7;
      }
    }
  }
  .ability-region {
  }
  .compare_wrap {
    width: 100%;
    box-sizing: border-box;
    height: 11.7vw;
    padding: 0 4.3vw;
    font-size: 3.7vw;
    background: #fff;
    border: solid 0.3vw #f1f1f1;
    border-radius: 1.6vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .compare_notice {
      display: flex;
      align-items: center;
    }
    .compare_icon {
      display: flex;
      align-items: center;
      span {
        color: #999;
        font-size: vw(16);
      }
      .notice_info {
        color: #dc0050;
        font-size: vw(11);
        margin-right: vw(10);
        text-align: right;
      }
    }
  }
}
</style>
